import { RangeInput } from 'shared/components/RangeInput';
import styles from './DropdownSuburbanArea.css';
import { FC } from 'react';
import { UIText2 } from '@cian/ui-kit';

interface IDropdownSuburbanAreaProps {
  landAreaMin: number | null;
  landAreaMax: number | null;
  houseAreaMin: number | null;
  houseAreaMax: number | null;
  isHouseAreaAvailable: boolean;

  onLandAreaMinChange: (value: number) => void;
  onLandAreaMaxChange: (value: number) => void;
  onHouseAreaMinChange: (value: number) => void;
  onHouseAreaMaxChange: (value: number) => void;
}

export const DropdownSuburbanArea: FC<IDropdownSuburbanAreaProps> = ({
  landAreaMin,
  landAreaMax,
  houseAreaMin,
  houseAreaMax,
  isHouseAreaAvailable,
  onLandAreaMinChange,
  onLandAreaMaxChange,
  onHouseAreaMinChange,
  onHouseAreaMaxChange,
}) => {
  const landAreaInput = (
    <RangeInput
      min={1}
      max={999999}
      valueMin={landAreaMin}
      valueMax={landAreaMax}
      onChangeMin={onLandAreaMinChange}
      onChangeMax={onLandAreaMaxChange}
      postfix="сот."
      joined={false}
    />
  );

  return (
    <div className={styles['dropdown']} data-testid="SuburbanAreaDropdown">
      {isHouseAreaAvailable ? (
        <div className={styles['dropdown-filter']}>
          <UIText2 fontWeight="bold">Дом</UIText2>
          <RangeInput
            min={1}
            max={99999}
            valueMin={houseAreaMin}
            valueMax={houseAreaMax}
            onChangeMin={onHouseAreaMinChange}
            onChangeMax={onHouseAreaMaxChange}
            postfix="м²"
            joined={false}
          />
          <UIText2 fontWeight="bold">Участок</UIText2>
          {landAreaInput}
        </div>
      ) : (
        landAreaInput
      )}
    </div>
  );
};
